import { useLazyQuery, useQuery } from "@apollo/client/react";
import { useMemo, useState, useEffect } from 'react';
import { Box, Grid, IconButton } from '@mui/material';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import { generateColumnsDefaultConfiguration } from '../../../../../components/dataGrid/columnHelpers';
import DataGridGenerico from '../../../../../components/dataGrid/DataGridGenerico';
import { CustomDialog } from '../../../../../components/customDialog/CustomDialog';
import { CustomButton } from '../../../../../components/customButton/CustomButton';
import { adaptOrigenMatriculaDerivadorArray, GET_ORIGEN_MATRICULA_DERIVADOR } from '../../../../../data/graphQL/queries/Contratos/DatosPrincipales/getOrigenMatriculaDerivador';
import { VALIDATE_MATRICULA_BY_ORIGEN } from '../../../../../data/graphQL/queries/Profesionales/validarMatriculaUnicidad';
import toast from 'react-hot-toast';
import { RenderInputByTypeMobile } from '../../../../../components/formGroupGenerator/RenderInputByTypeMobile';

export const Matriculas = ({
  datosSeleccionFormData,
  handleChange,
  allowedWrite,
  idTipoProfesional
}) => {
  const [openModal, setOpenModal] = useState(false);
  const [nuevaMatriculaData, setNuevaMatriculaData] = useState({});
  const [origenesMatricula, setOrigenesMatricula] = useState([]);

  const handleChangeMatricula = (name, value) => {
    setNuevaMatriculaData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };

  const resetMatricula = () => setNuevaMatriculaData({});

  const handleOpenModal = () => {
    if (!idTipoProfesional) return toast.error("Para cargar una matricula es necesario cargar el Tipo de Profesional");
    setOpenModal(true);
  };
  const handleCloseModal = () => {
    setOpenModal(false);
    resetMatricula();
  };

  const { data: dataOrigenes, error: errorOrigenes } = useQuery(GET_ORIGEN_MATRICULA_DERIVADOR, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataOrigenes) return;
    if (dataOrigenes.allOrigenMatricula.length > 0)
      setOrigenesMatricula(adaptOrigenMatriculaDerivadorArray(dataOrigenes.allOrigenMatricula));
  }, [dataOrigenes]);

   useEffect(() => {
    if (!errorOrigenes) return;
    toast.error("No fue posible consultar los Orígenes de las matrículas");
  }, [errorOrigenes]);

  const [validarNuevaMatriculaUnicidad, { data: dataValidar, error: errorValidar }] = useLazyQuery(VALIDATE_MATRICULA_BY_ORIGEN, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataValidar) return;
    if (!dataValidar.existeMatriculaProfesionalByOrigen) {
      toast.success("Se ha validado correctamente la matricula.");
      const matriculas = [...(datosSeleccionFormData?.matriculas ?? [])];
      handleChange('matriculas', [...matriculas, nuevaMatriculaData]);
    } else
      toast.error("El origen y el número de matrícula ya existe para otro profesional.");
  }, [dataValidar]);

  useEffect(() => {
    if (!errorValidar) return;
    toast.error("No fue posible validar la unicidad de la matrícula.");
    return false;
  }, [errorValidar]);

  const handleSaveNuevo = async () => {
    const nodo = datosSeleccionFormData?.matriculas?.filter((m) => m.idOrigenMatricula == nuevaMatriculaData?.idOrigenMatricula);
    if (!!nodo && nodo?.length > 0) {
      toast.error("El Origen de la matrícula ya se encuentra ingresado.");
    } else {
      await validarNuevaMatriculaUnicidad({
        variables: {
          idOrigenMatricula: nuevaMatriculaData?.idOrigenMatricula,
          numero: nuevaMatriculaData?.numero,
          idTipoProfesional
        }
      });
      handleCloseModal();
    }
  };

  const handleDeleteRow = (idOrigenMatricula) => {
    const filteredValue = datosSeleccionFormData?.matriculas.filter((matricula) => matricula.idOrigenMatricula !== idOrigenMatricula);
    handleChange('matriculas', filteredValue);
  };

  const columns = [
  {
    field: 'action',
    headerName: '',
    align: 'center',
    renderCell: ({ row }) => {
      return (
        <IconButton disabled={!allowedWrite} onClick={() => handleDeleteRow(row.idOrigenMatricula)}>
                        <DeleteOutlinedIcon color={!allowedWrite ? 'disabled' : 'action'} />
                    </IconButton>);

    }
  },
  {
    field: 'idOrigenMatricula',
    headerName: 'Origen',
    flex: 2,
    valueGetter: (idOrigenMatricula) => {
      return origenesMatricula?.find((x) => x.id === idOrigenMatricula)?.displayName;
    }
  },
  {
    field: 'fechaVencimiento',
    headerName: 'F. Vencimiento',
    type: 'date',
    flex: 2
  },
  {
    field: 'numero',
    headerName: 'Numero',
    flex: 2
  }];


  const CONFIGURATED_COLUMNS = useMemo(() => generateColumnsDefaultConfiguration(columns), [columns, allowedWrite, origenesMatricula]);

  const createDisabled = useMemo(() =>
  !nuevaMatriculaData.idOrigenMatricula ||
  !nuevaMatriculaData.fechaVencimiento ||
  !nuevaMatriculaData.numero?.trim() ||
  !allowedWrite,
  [nuevaMatriculaData]);

  return (
    <>
            <Grid container sx={{ marginTop: '20px' }} rowSpacing={1}>
                <Grid size={{ xs: 12 }}>
                    <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
                        <h4 style={{ margin: 0 }}>Matriculas Cargadas</h4>
                        <CustomButton
              label='Agregar Matricula'
              variant='outlined'
              onClick={handleOpenModal}
              disabled={!allowedWrite} />
            
                    </Box>
                </Grid>
                <Grid size={{ xs: 12 }}>
                    <DataGridGenerico
            rows={datosSeleccionFormData?.matriculas}
            columns={CONFIGURATED_COLUMNS}
            hideFooterPagination={false}
            toolbar={false}
            localeText={{ noRowsLabel: 'No se han cargado matriculas' }} />
          
                </Grid>
            </Grid>
            <CustomDialog
        title='Nueva Matricula'
        fullWidth
        maxWidth='md'
        open={openModal}
        onAccept={handleSaveNuevo}
        onCancel={handleCloseModal}
        acceptText='Guardar'
        cancelText='Cancelar'
        acceptDisabled={createDisabled}>
        
                <Grid container spacing={2}>
                    <Grid size={{ xs: 4 }}>
                        <RenderInputByTypeMobile
              input={{
                displayName: 'Origen Matricula',
                name: 'idOrigenMatricula',
                type: 'autocomplete',
                options: origenesMatricula
              }}
              handleChange={handleChangeMatricula}
              value={nuevaMatriculaData?.idOrigenMatricula} />
            
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <RenderInputByTypeMobile
              input={{
                displayName: 'F. Vencimiento',
                name: 'fechaVencimiento',
                type: 'date'
              }}
              handleChange={handleChangeMatricula}
              value={nuevaMatriculaData?.fechaVencimiento} />
            
                    </Grid>
                    <Grid size={{ xs: 4 }}>
                        <RenderInputByTypeMobile
              input={{
                displayName: 'Numero',
                name: 'numero',
                type: 'string'
              }}
              handleChange={handleChangeMatricula}
              value={nuevaMatriculaData?.numero} />
            
                    </Grid>
                </Grid>
            </CustomDialog>
        </>);

};